(function () {
  var MIN_HEADINGS = 2;
  var HEADING_SELECTOR = 'h2';

  function slugify(text, index) {
    var slug = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\u4e00-\u9fff\s-]/gi, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    return slug || 'section-' + (index + 1);
  }

  function getHeaderOffset() {
    var header = document.querySelector('.shopify-section-header-sticky, .shopify-section-header-always-sticky');
    if (!header) return 96;
    return header.getBoundingClientRect().height + 16;
  }

  function scrollToHeading(id) {
    var target = document.getElementById(id);
    if (!target) return;

    var top = window.scrollY + target.getBoundingClientRect().top - getHeaderOffset();
    window.scrollTo({ top: top, behavior: 'smooth' });
    history.replaceState(null, '', '#' + id);
  }

  function setActiveLink(links, activeId) {
    links.forEach(function (link) {
      var isActive = link.getAttribute('href') === '#' + activeId;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function getTocInsertTarget(contentRoot, headings) {
    return headings[0] || contentRoot.querySelector('h2') || null;
  }

  function initArticleToc(container) {
    if (container.dataset.articleTocInitialized === 'true') return;

    var contentRoot = document.querySelector('.article-template__content-rte');
    if (!contentRoot) return;

    var headings = Array.prototype.filter.call(
      contentRoot.querySelectorAll(HEADING_SELECTOR),
      function (heading) {
        return heading.textContent.trim().length > 0;
      }
    );

    if (headings.length < MIN_HEADINGS) {
      container.remove();
      return;
    }

    var insertTarget = getTocInsertTarget(contentRoot, headings);
    if (!insertTarget) {
      container.remove();
      return;
    }

    var usedIds = {};
    headings.forEach(function (heading, index) {
      if (heading.id) {
        usedIds[heading.id] = true;
        return;
      }

      var base = slugify(heading.textContent, index);
      var id = base;
      var suffix = 2;

      while (usedIds[id] || document.getElementById(id)) {
        id = base + '-' + suffix;
        suffix += 1;
      }

      heading.id = id;
      usedIds[id] = true;
    });

    var list = container.querySelector('[data-article-toc-list]');
    var toggle = container.querySelector('.article-toc-cottolio__toggle');
    if (!list || !toggle) return;

    var links = [];

    headings.forEach(function (heading) {
      var item = document.createElement('li');
      item.className = 'article-toc-cottolio__item';

      var link = document.createElement('a');
      link.className = 'article-toc-cottolio__link';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();

      link.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToHeading(heading.id);
        setActiveLink(links, heading.id);
      });

      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    });

    toggle.addEventListener('click', function () {
      var collapsed = container.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var visible = entries
            .filter(function (entry) {
              return entry.isIntersecting;
            })
            .sort(function (a, b) {
              return a.boundingClientRect.top - b.boundingClientRect.top;
            });

          if (visible.length > 0) {
            setActiveLink(links, visible[0].target.id);
          }
        },
        {
          rootMargin: '-' + getHeaderOffset() + 'px 0px -55% 0px',
          threshold: 0,
        }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    } else if (links.length > 0) {
      links[0].classList.add('is-active');
      links[0].setAttribute('aria-current', 'location');
    }

    container.hidden = false;
    container.classList.add('article-toc-cottolio--in-flow');
    contentRoot.insertBefore(container, insertTarget);
    container.dataset.articleTocInitialized = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-article-toc]').forEach(initArticleToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
